import { TaskActivity } from "./activity";
import { Event } from "./event";

export enum TaskStatus {
  OFFEN = 'OFFEN',
  FERTIG = 'FERTIG',
  ABGELEHNT = 'ABGELEHNT',
}

export enum TaskType {
  MEHRBEDARF = 'MEHRBEDARF',
  UEBERGABE_VORSCHLAG = 'UEBERGABE_VORSCHLAG',
  MEDIZINISCHE_FRAGEN = 'MEDIZINISCHE_FRAGEN',
  WARENKORB_AENDERUNG_KUNDENWUNSCH = 'WARENKORB_AENDERUNG_KUNDENWUNSCH',
  LIEFERUNG_PAUSIEREN = 'LIEFERUNG_PAUSIEREN',
  MERKMAL_KUNDENABSPRACHE = 'MERKMAL_KUNDENABSPRACHE',
  BESTAETIGUNG_ERSTKONTAKT = 'BESTAETIGUNG_ERSTKONTAKT',
  KUNDEN_NEUANLAGE = 'KUNDEN_NEUANLAGE',
}

export interface Task extends Event {
  id: string;
  patientId: string;
  integratedCareId: string;
  status: TaskStatus;
  type: TaskType;
  activities: Array<TaskActivity>;
}

export interface PatientTask extends Task {
  patientId: string;
}

export interface IntegratedCareTask extends Task {
  integratedCareId: string;
}
